import { IconMail, IconMailOff } from "@tabler/icons-react";

// Whether the members get the post by e-mail at its publish moment. `value`
// is sent as the API's `notify_members`. New posts default to notifying.
export const DEFAULT_NOTIFY = true;

// Labels are resolved at call time so they follow the active language.
export const getNotifyOptions = (t) => [
    {
        value: true,
        Icon: IconMail,
        label: t("publishPost.notify.options.notify.label"),
        button: t("publishPost.notify.options.notify.button"),
        description: t("publishPost.notify.options.notify.description"),
    },
    {
        value: false,
        Icon: IconMailOff,
        label: t("publishPost.notify.options.feedOnly.label"),
        button: t("publishPost.notify.options.feedOnly.button"),
        description: t("publishPost.notify.options.feedOnly.description"),
    },
];
